import type { OrgConfig, OrgConfigPublic, OrgConfigUpdate } from '@lms/shared-types'
import { apiRequest } from './client'

export function getOrgConfig(): Promise<OrgConfig> {
  return apiRequest<OrgConfig>('/api/v1/org-config')
}

export function getPublicOrgConfig(): Promise<OrgConfigPublic> {
  return apiRequest<OrgConfigPublic>('/api/v1/org-config/public')
}

/** Admin-only PATCH. Omitted fields are left untouched. */
export function updateOrgConfig(patch: OrgConfigUpdate): Promise<OrgConfig> {
  return apiRequest<OrgConfig>('/api/v1/org-config', {
    method: 'PATCH',
    body: patch,
  })
}

/** HR+ — send a test email via the configured provider (Mailgun SMTP).
 *  Returns delivered=true when the provider accepted the message; false when
 *  it's off / misconfigured / errored (still a 200 — the seam never raises).
 *  Optional `to` overrides the recipient; defaults to the actor's own email. */
export function sendTestEmailHr(to?: string): Promise<{ delivered: boolean }> {
  return apiRequest<{ delivered: boolean }>('/api/v1/hr/email/test', {
    method: 'POST',
    body: to ? { to } : {},
  })
}
